import { ChakraBox, ChakraFlex, SkeletonLoader } from '@equip.health/ui';

const MyPatientsSkeleton = () => (
  <ChakraFlex
    data-testid="my-patients-skeleton"
    direction="column"
    gap="8px"
    width="100%"
  >
    {[...Array(10)].map((_, i) => (
      <ChakraBox key={i} borderRadius="8px" overflow="hidden">
        <SkeletonLoader
          height="52px"
          width="100%"
          id={`my-patients-skeleton-row-${i}`}
          startColor="neutral.line"
          endColor="neutral.background.secondary"
        />
      </ChakraBox>
    ))}
  </ChakraFlex>
);

export default MyPatientsSkeleton;
